export enum OperatorInvoiceStatus {
  Generated = 1,
  Sent = 2,
  Cancelled = 3
}

export enum OperatorInvoiceAdjustmentReason {
  UserCancellation = 1,
  AdminReservationCancellation = 2,
  AdminTicketCancellation = 3,
  OperatorSwitchAway = 4,
  OperatorSwitchTo = 5,
  InvoiceOnlyCancel = 6
}

export interface IOperatorInvoicePreviewItem {
  journeyReservationId: number;
  tripId: number;
  uniqueJourneyId: string;
  paymentDate: string;
  journeyDate: string;
  lineName: string;
  passengerCount: number;
  totalPrice: number;
  commissionRate: number;
  commissionAmount: number;
  operatorAmount: number;
}

export interface IOperatorInvoiceCancellation {
  adjustmentId: number;
  ticketId: number;
  uniqueJourneyId: string;
  amount: number;
  reason: OperatorInvoiceAdjustmentReason;
  eventDateUtc: string;
}

export interface IOperatorInvoicePreview {
  operatorId: number;
  operatorName: string;
  periodFrom: string;
  periodTo: string;
  reservationRowsCount: number;
  cancellationRowsCount: number;
  totalPrice: number;
  totalGjirafaCommission: number;
  totalOperatorAmount: number;
  totalCancellations: number;
  netBillable: number;
  items: IOperatorInvoicePreviewItem[];
  cancellations: IOperatorInvoiceCancellation[];
}

export interface IOperatorInvoice {
  id: number;
  operatorId: number;
  periodFrom: string;
  periodTo: string;
  statusId: OperatorInvoiceStatus;
  totalPrice: number;
  totalGjirafaCommission: number;
  totalOperatorAmount: number;
  totalCancellations: number;
  netBillable: number;
  sentAtUtc: string | null;
  cancelledAtUtc: string | null;
  cancelledByUserId: number | null;
  docSheetUpdatedAtUtc: string | null;
  insertDate: string;
  updateDate: string;
  createdBy: number | null;
  updatedBy: number | null;
  deleted: boolean;
}

export interface IOperatorInvoiceRange {
  operatorId: number;
  from: string;
  to: string;
}

export interface IInvoiceCancelTicketBody {
  reason: string;
}

export interface IInvoiceCancelTicketResponse {
  cancellationId: number;
}

export interface IMarkSentResponse {
  success: boolean;
  driveFolderUrl: string;
  emailSent: boolean;
}
